module.exports = __webpack_public_path__ + "img/caracole.ce8c002.jpg";